export const logoNameMap = new Map([
  ['2BB', 'logo-2bb.png'],
  ['ADIDAS', 'logo-adidas.png'],
  ['ADRIENNE VITTADINI', 'logo-adrienne-vittadini.png'],
  ['BLOOM', 'logo-bloom.png'],
  ['BROOKS BROTHERS', 'logo-brooks-bros.png'],
  ['BURBERRY', 'logo-burberry.png'],
  ['CARRERA', 'logo-carrera.png'],
  ['CHLOE', 'logo-chloe.png'],
  ['COACH', 'logo-coach.png'],
  ['COSTA', 'logo-costa.png'],
  ['DANNY GOKEY', 'logo-danny-gokey.png'],
  ['DOLCE & GABBANA', 'logo-dolce-gabbana.png'],
  ['EMPORIO ARMANI', 'logo-emporio-armani.jpg'],
  ['EVATIK', 'logo-evatik.png'],
  ['SCUDERIA FERRARI', 'logo-scuderia-ferrari.png'],
  ['FILA', 'logo-fila.png'],
  ['FYSH', 'logo-fysh.png'],
  ['GARGOYLES', 'logo-gargoyles.png'],
  ['GIORGIO ARMANI', 'logo-giorgio-armani.png'],
  ['GLEMAUD', 'logo-glemaud.png'],
  ['GLEMAUD X TURA', 'logo-glemaud.png'],
  ['GUCCI', 'logo-gucci.png'],
  ['GUESS', 'logo-guess.png'],
  ['GUESS BY MARCIANO', 'logo-guess-marciano.png'],
  ['GWEN STEFANI GX', 'logo-gwen-stefani-gx.png'],
  ['HACKETT', 'logo-hackett.png'],
  ['HELIUM PARIS', 'logo-helium-paris.png'],
  ['JIMMY CHOO', 'logo-jimmy-choo.png'],
  ['KATE SPADE', 'logo-kate-spade.png'],
  ['KENZO', 'logo-kenzo.png'],
  ['KLIIK', 'logo-kliik.png'],
  ['KOALI', 'logo-koali.png'],
  ['L.A.M.B.', 'logo-lamb.png'],
  ['LIGHTEC', 'logo-lightec.png'],
  ['MARC JACOBS', 'logo-marc-jacobs.png'],
  ['LULU GUINNESS', 'logo-lulu-guinness.png'],
  ['MICHAEL KORS', 'logo-michael-kors.png'],
  ['MARCIANO', 'logo-marciano.png'],
  ['MODERN METALS','logo-modern-metals.jpg'],
  ['MODERN PLASTICS I','logo-modern-plastics-i.jpg'],
  ['MODERN PLASTICS II','logo-modern-plastics-ii.jpg'],
  ['MOREL', 'logo-morel.png'],
  ['OAKLEY', 'logo-oakley.png'],
  ['OGA', 'logo-oga.png'],
  ['OLIVER PEOPLES', 'logo-oliver-peoples.png'],
  ['PERSOL', 'logo-persol.png'],
  ['POLO', 'logo-polo.png'],
  ['PRADA', 'logo-prada.png'],
  ['PRADA LINEA ROSSA', 'logo-prada-linea-rossa.png'],
  ['PUMA', 'logo-puma.png'],
  ['RALPH', 'logo-ralph.png'],
  ['RAY BAN', 'logo-rayban.png'],
  ['RISERVA', 'logo-riserva.png'],
  ['SAINT LAURENT', 'logo-saint-laurent.png'],
  ['SUPERFLEX', 'logo-superflex.png'],
  ['SWAROVSKI', 'logo-swarovski.png'],
  ['TED BAKER', 'logo-ted-baker.png'],
  ['TED BAKER KIDS', 'logo-ted-baker-kids.png'],
  ['TIFFANY', 'logo-tiffany.png'],
  ['TIMBERLAND', 'logo-timberland.png'],
  ['TITANFLEX', 'logo-titanflex.png'],
  ['TOM FORD', 'logo-tom-ford.png'],
  ['TOMMY HILFIGER', 'logo-tommy-hilfiger.png'],
  ['TORY BURCH', 'logo-tory-burch.png'],
  ['TURA', 'logo-tura.png'],
  ['VERSACE', 'logo-versace.png'],
  ['VISION SOURCE SMART', 'logo-vision-source-smart.png'],
  ['VOGUE', 'logo-vogue.png'],
  ['ALLSAINTS', 'logo-allsaints.png'],
  ['MIRAFLEX', 'logo-miraflex.png'],
  ['STEPPER', 'logo-stepper.jpg'],
]);
